import { Component, OnInit ,Input,Output,EventEmitter} from '@angular/core';
@Component({
  selector: 'app-lightbox',
  templateUrl: './lightbox.component.html',
  styleUrls: ['./lightbox.component.css']
})
export class LightboxComponent implements OnInit {

    header:string = '系統訊息';
    @Input() content: string;
    @Output() callback: EventEmitter<any> = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
    console.log('use lightbox');
  }

  go(staus:boolean){
    this.callback.emit(staus);
  }

}
